import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";

export default function AuthCallback() {
  const { applySession } = useAuth();
  const nav = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sid) { nav("/login", { replace: true }); return; }
    api.post("/auth/session", {}, { headers: { "X-Session-ID": sid } })
      .then((r) => {
        applySession(r.data);
        window.history.replaceState(null, "", "/dashboard");
        nav("/dashboard", { replace: true });
      })
      .catch(() => { nav("/login", { replace: true }); });
  }, [applySession, nav]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#FBFBF9]">
      <div className="flex flex-col items-center gap-3">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-stone-300 border-t-navy" />
        <p className="text-sm text-stone-500">Signing you in…</p>
      </div>
    </div>
  );
}
